"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.SectionNav = void 0;
var _sectionNav = _interopRequireDefault(require("./components/section-nav"));
exports.SectionNav = _sectionNav["default"];